import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import type { QueryHookOptions } from '@apollo/client'
import { useQuery } from '@apollo/client'
import {
  GetReassuranceCardsDocument,
  type GetReassuranceCardsQuery,
  type GetReassuranceCardsQueryVariables,
} from '@gql-generated/graphql'
import { useTenantId } from './useTenantId'

type UseReassuranceCardsOptions = QueryHookOptions<
  GetReassuranceCardsQuery,
  GetReassuranceCardsQueryVariables
>

export function useReassuranceCards(options: UseReassuranceCardsOptions = {}) {
  const tenantId = useTenantId({ skip: options.skip ?? false })

  const { data } = useQuery(GetReassuranceCardsDocument, {
    ...APOLLO_CLIENT_SIDE_OPTIONS,
    ...options,
    variables: { tenantId },
  })

  return data?.CMS_ReassuranceCards?.docs[0]?.layout
}
